module.exports = __webpack_public_path__ + "static/media/icon_circular_bin.6d813837.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_circular_bin.svg
// module id = 1850
// module chunks = 0